<script setup lang="ts">
const metaThemeColor = document.querySelector('meta[name=theme-color]');
metaThemeColor?.setAttribute('content', 'black');
</script>

<template>
  <div id="wrapper" class="h-full overflow-hidden font-light font-sans bg-black">
    <div class="flex items-center justify-center h-full p-4 text-white">
      <div id="content-container"
           class="flex flex-col items-center w-full w-screen md:max-h-3/4 h-full justify-center relative">
        <div class="flex flex-col justify-center items-center">
          <svg class="stroke-current" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 180 180">
            <path stroke-width="13" stroke-linecap="round" d="M89,9a81,81 0 1,0 2,0zm1,38v58m0,25v1"/>
          </svg>
          <div class="flex h-full justify-center items-center">
            <div class="text-lg">
              {{ $t('nfc.notfound') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
